import { Card } from 'react-bootstrap';

const DashboardStatisticCard = ({
  title,
  value,
  change,
  description,
  icon,
  bgClass,
  increaseClass,
}) => {
  return (
    <Card className={`shadow-none border dashboard-card ${bgClass} info-card`}>
      <Card.Body className="p-3 d-flex justify-content-between align-items-start">
        <div>
          <Card.Title className="fs-6 text-muted">{title}</Card.Title>
          <h4 className="fw-bold fs-6 mb-3">{value}</h4>
          <Card.Text className="fw-5 mb-2 fs-14">
            {change ? <span className={increaseClass}>{change}</span> : null}
            {change ? ' ' : ''}
            {description}
          </Card.Text>
        </div>

        <div className="d-flex align-items-center justify-content-center">
          {icon}
        </div>
      </Card.Body>
    </Card>
  );
};

export default DashboardStatisticCard;